function get_wishlist(){
  
  window.SwymCallbacks = window.SwymCallbacks || [];
            window.SwymCallbacks.push(function(swat) {
              $("#swym-wishlist-render-container").empty()
              var wishlistContainerElement = document.querySelector("#swym-wishlist-render-container");
              var queryParams = swat.utils.getEncodedAsObject(window.location.search);
              // Contains queryParams["lid"] to render a specific list id
              swat.ui.renderWishlistInContainer(wishlistContainerElement, queryParams);
            });
}

function addremwishlist(){
    //Executed after SWYM has loaded all necessary resources.
              
            function onSwymLoadCallback(swat) {
              // Fetch the users wishlist and print it to the console.
                swat.fetch(function(allWishlistedProducts) {
                  // Prints the current users wishlist - 
                  console.log("successfully retrieved the wishlist", allWishlistedProducts);
                  var all_wishproduct = [];
                  for(wish of allWishlistedProducts){
                   all_wishproduct.push(wish.epi)
                  }
                  setTimeout(function(){
                    $('.impulse_cart_item').each(function(){
                    
                    if(all_wishproduct.includes($(this).data('cartvariantid'))){
                      console.log($(this))
                      $(this).find('.move-to-wishlist-btn_impulse').css('display','none');
                      $(this).find('.remove-from-wishlist-btn_impulse').css('display','block')
                    }else{
                      $(this).find('.move-to-wishlist-btn_impulse').css('display','block');
                      $(this).find('.remove-from-wishlist-btn_impulse').css('display','none')
                    }
                  })
                  },1000)
                  
                }, function(error) {
                  console.log("There was an error while fetching the wishlist", error)
                });
            }
              if (!window.SwymCallbacks) {
                window.SwymCallbacks = [];
              }
              window.SwymCallbacks.push(onSwymLoadCallback);
}

function getall_price(){
   var all_price = [];
   var all_quantity = [];
  $('.new_element_added').each(function(){
    variant_price = $(this).data('appended_variantprice')
    quantity = $(this).find('.appended_quantity_input').val()
    all_price.push(variant_price*quantity)
    all_quantity.push(parseInt(quantity))
  })
  var sum_allprice = 0;
     
    // Running the for loop
    for (let i = 0; i < all_price.length; i++) {
        sum_allprice += all_price[i];
    }
  var sum_all_quantity = 0;
     
    // Running the for loop
    for (let i = 0; i < all_quantity.length; i++) {
        sum_all_quantity += all_quantity[i];
    }
  $('.total_appended_price_impulse').text(theme.Currency.formatMoney(sum_allprice, theme.settings.moneyFormat))
  $('.total_appended_quantity_impulse').text('('+sum_all_quantity+')')
}

//product page
$('body').delegate('.impulse_variant_button','change',function(){
  
   let vaariant_id = window.location.href.split("")
   $('.impulse_variant_button').each(function(){
        $(this).next().removeClass('add_border')
    })
  $(this).closest('.variant-wrapper_impulse').next().find('.impulse_variant-input-wrap').prop('disabled',false)
  setTimeout(function(){
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
    var options = ''
    $('.impulse_variant_button').each(function(){
      if($(this).is(":checked")){
        symbol ='';
           if(options != ''){
             symbol =' / ';
           }
          options = options + symbol+ $(this).val()
      }
      
    })
    $('.variant_ced').each(function(){
    if($(this).text() == options){
      var variantid = $(this).data('variantid');
      match_div =''
      $('.new_element_added').each(function(){
        if($(this).data('appended_variantid') == variantid){
          match_div = $(this);
        }
      })
      // 변경 후
if(match_div != ''){
  match_div.find('.appended_quantity_input').val(parseInt(match_div.find('.appended_quantity_input').val())+1)
  getall_price()
}else{
      var img_element ='';
      if($(this).data('variantimg') != undefined){
      img_element = `<div class="product_image_wrapper">
                    <img src="`+$(this).data('variantimg')+`">
                    </div>`
      }
      var newelement = `<div class="new_element_added" data-appended_variantid="`+$(this).data('variantid')+`" data-appended_variantprice="`+$(this).data('variantprice')+`">
                          <div class="appended_variant_wrapper">
                            <div class="appended_title">`+$(this).data('producttitle')+`</div>
                            <div class="appended_variant_title">`+$(this).text()+`</div>
                          </div>
                          <div class="appended_quantity_wrapper">
                            <button class="appended_minus_btn">-</button>
                            <input class="appended_quantity_input" type="text" pattern="[0-9]*" value="1" min="1">
                            <button class="appended_plus_btn">+</button>
                          </div>
                          <div class="appended_price_wrapper">`+theme.Currency.formatMoney($(this).data('variantprice'), theme.settings.moneyFormat)+`</div>
                          <div class="remove_btn_wrapper">
                            <button class="remove_appended_variant">X</button>
                          </div>
                        </div>`
        if(parseInt($(this).data('variantinvqn')) > 0 || $(this).data('variantinvpolicy') == 'continue'){
      $('.added_variants_impulse').append(newelement)
          $('.custom_add_to_cart').prop('disabled',false)
        }
         
       getall_price()
        // $('.impulse_variant-input-wrap').each(function(){
        //   if($(this).data('index') != 'option1'){
        //     $(this).prop('disabled',true)
        //   }
        // })
      }
    }
  })
    
  },500)
  setTimeout(() => {
    let urlParams = new URLSearchParams(window.location.search);
    let variant_id = urlParams.get("variant");
    
    let wishListBtns = document.querySelectorAll("[data-ced-wishlist='']");
    wishListBtns.forEach((btn) => {
      btn.setAttribute("data-wishlistvariantid", variant_id);
    });
    $('.wishlist_wrapper_product').attr('data-productvariantid',variant_id)
    console.log("172");
    console.log(variant_id);
    
    //Executed after SWYM has loaded all necessary resources.
  function onSwymLoadCallback(swat) {
    // Fetch the users wishlist and print it to the console.
      swat.fetch(function(allWishlistedProducts) {
        // Prints the current users wishlist - 
        // console.log("successfully retrieved the wishlist", allWishlistedProducts);
        var all_wishproduct = [];
        for(wish of allWishlistedProducts){
         all_wishproduct.push(wish.epi)
        }
        
        $('.wishlist_wrapper_product').each(function(){
          console.log(all_wishproduct,$(this).attr('data-productvariantid'))
          if(all_wishproduct.includes(parseInt($(this).attr('data-productvariantid')))){
            console.log("189");
            console.log('in')
            $(this).find('.product_move-to-wishlist-btn_impulse').css('display','none');
            $(this).find('.product_remove-from-wishlist-btn_impulse').css('display','block')
          }else{
            console.log("194");
            console.log('out')
            $(this).find('.product_move-to-wishlist-btn_impulse').css('display','block');
            $(this).find('.product_remove-from-wishlist-btn_impulse').css('display','none')
          }
        })
      }, function(error) {
        console.log("201");
        console.log("There was an error while fetching the wishlist", error)
      });
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
    
  }, 500);
})

$('body').delegate('.appended_minus_btn','click',function(){
  input_value = $(this).next().val()
  if(input_value > 1){
    $(this).next().val(parseInt(input_value)-1)
  }
  getall_price()
})

$('body').delegate('.appended_plus_btn','click',function(){
  input_value = $(this).prev().val()
    $(this).prev().val(parseInt(input_value)+1)
  getall_price()
})

$('body').delegate('.remove_appended_variant','click',function(){
  $(this).parent().parent().remove()
  getall_price()
  if($('.new_element_added').length == 0){
    $('.custom_add_to_cart').prop('disabled',true)
  }
})

$('body').delegate('.appended_quantity_input','change',function(){
  getall_price()
})

$('body').delegate('.custom_add_to_cart','click',function(){
  var all_ids = [];
  $('.new_element_added').each(function(){
    variant_id = $(this).data('appended_variantid')
    quantity = $(this).find('.appended_quantity_input').val()
    all_ids.push({id:variant_id,quantity: quantity})
  })
  console.log("246");
  console.log(all_ids)
  let formData = {
      'items': all_ids
      };
      if(all_ids.length != 0){
       $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
            data:  formData,
            success: function(json){
              $('.drawer__contents_cart').css('display','block');
            $('.wishlist_content_cart').css('display','none');
              $("#cartBtn").addClass("btn-active");
            $("#wishlistBtn").removeClass("btn-active");
              get_wishlist()
             var cart = new theme.CartDrawer
              cart.init()
              cart.open();
              addremwishlist()
              $.getJSON("/cart.js", function(cart){
                    
                    $('.cart-link__bubble').addClass('cart-link__bubble--visible')
                 
                  
                  $('.cart-link__bubble').text('('+cart.item_count+')')
                  })
                 $(".added_variants_impulse").empty()
                $('.custom_add_to_cart').prop('disabled',true)
                $('.impulse_variant_button').each(function(){
                $(this).next().removeClass('add_border')
                $(this).prop('checked', false)
                })
                
                },
              error:  function(xhr, status, error){console.log("281");console.log(xhr.responseText);}
           })
      }
})

//contact page

function query_change(val){
  if(val == 'exchange_return'){
    $('.order_number_wrapper').css('display','block')
  }else{
    $(".ordererr").html("");
    $('.order_number_wrapper').css('display','none')
  }
}
$('.query_selector').change(function(){
  query_change($(this).val())
})

query_change($('.query_selector').val())


//faq

var acc = document.getElementsByClassName("faq_accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("faq_active");
    var panel = this.nextElementSibling;
    var blockid = this.nextElementSibling.dataset.blockid;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
    var descriptions = document.getElementsByClassName("faq_description");
    for(var description of descriptions){
      if(description.dataset.blockid != blockid){
        description.style.maxHeight = null;
        description.previousElementSibling.classList.remove("faq_active")
      }
    }
  })
}

$('.faq_select').change(function(){
  var selected_value = $(this).val();
  if(selected_value == 'VIEW ALL'){
     $('.faq_block').each(function(){
       // $(this).css('display','block')
       location.reload()
     })
  }else{
    $('#page_navigation').css('display','none')
    $('.faq_block').each(function(){
    if($(this).data('blockshow')!=selected_value){
      $(this).css('display','none')
    }else{
      $(this).css('display','block')
    }
  })
    if($('.faq_blocks_wrapper').hasClass('faq_lines') == false){
      $('.faq_blocks_wrapper').addClass('faq_lines')
    }
  }
  
})

// login form

var emailErr = '',
pswErr = '';
$(".customer_email").keyup(function () {
$("#customer_login").attr("onsubmit", '');
let email = $(this).val();
emailErr = checkEmailLogin(email);
});
$(".customer_password").keyup(function () {
$("#customer_login").attr("onsubmit", '');
let psw = $(this).val();
pswErr = checkPswLogin(psw);
});
$(".form-login").click(function (e) {
 e.preventDefault();
var email = $(".customer_email").val();
var psw = $(".customer_password").val();
emailErr = checkEmailLogin(email);
pswErr = checkPswLogin(psw);
if (emailErr === true && pswErr === true) {
  $("#customer_login").submit();
}
});
/*
* recovery form validate
*/
var emailRevErr='';
function checkRecoveryEmail(email) {
if (email === "") {
  $(".recovery_email_error").removeClass("custom-hide").addClass("custom-show");
  $(".recovery_email_error").html("This field is required.");
  return false;
} else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || email.match(/^[0-9]/)) {
  $(".recovery_email_error").removeClass("custom-hide").addClass("custom-show");
  $(".recovery_email_error").html("Invalid email.");
  return false;
 // $error1 = false;
} else {
  $(".recovery_email_error").removeClass("custom-hide").addClass("custom-show");
  $(".recovery_email_error").html("");
  return true;
}
}
$(".customer_recovery_email").keyup(function () {

let email = $(this).val();
emailRevErr = checkRecoveryEmail(email);
});
$(".submit-recovery").click(function (e) {
 e.preventDefault();
var email = $(".customer_recovery_email").val();
emailRevErr = checkRecoveryEmail(email);
  
if (emailRevErr === true) {
  $(".recover_password_ced").submit();
}
});
/*
* recovery form validate end
*/


function checkEmailLogin(email) {
if (email === "" || email.charAt(0) === " ") {
  $("#LoginForm-email-error").html("This field is required.");
  return false;
} else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || email.match(/^[0-9]/)) {
  $("#LoginForm-email-error").html("Invalid email.");
  return false;
 // $error = false;
} else {
  $("#LoginForm-email-error").html("");
  return true;
}
}
function checkPswLogin(psw) {
if (psw === "") {
  $("#LoginForm-password-error").html("This field is required.");
  return false;
} else {
  $("#LoginForm-password-error").html("");
  return true;
}
}

// login end

//register form

$(document).ready(function () {
  var fnameErr = '',
    lnameErr = '',
    emailErr = '',
    pswErr = '';
  $("#FirstName").keyup(function () {
    $("#create_customer").attr("onsubmit", '');
    let fname = $(this).val();
    fnameErr = checkFname(fname);
  });
  $("#LastName").keyup(function () {
    $("#create_customer").attr("onsubmit", '');
    let lname = $(this).val();
    lnameErr = checkLname(lname);
  });
  $("#Email").keyup(function () {
    $("#create_customer").attr("onsubmit", '');
    let email = $(this).val();
    emailErr = checkEmail(email);
  });
  $("#CreatePassword").keyup(function () {
    $("#create_customer").attr("onsubmit", '');
    let psw = $(this).val();
    pswErr = checkPsw(psw);
  });
  $(".create_form-submit").click(function (e) {
    $("#create_customer").attr("onsubmit", '');
    e.preventDefault();
    let error = false;

    var fname = $("#FirstName").val(),
      lname = $("#LastName").val(),
    email = $("#Email").val(),
    psw = $("#CreatePassword").val(),
    fnameErr = checkFname(fname),
    lnameErr = checkLname(lname),
    emailErr = checkEmail(email),
    pswErr = checkPsw(psw);
    if (fnameErr === true && lnameErr === true && emailErr === true && pswErr === true) {
      $("#create_customer").submit();
    }
  });


  function checkFname(fname) {
    if (fname === "") {
      $("#RegisterForm-fname-error").html("This field is required.");
      return false;
    }else if (fname.charAt(0) === " ") {
      $("#RegisterForm-fname-error").html("* Name should not start with Blank Spaces.");
      return false;
    }else if (!fname.match(/^[A-Za-z\s\-]+$/)) {
      $("#RegisterForm-fname-error").html("Only letters and white space allowed.");
      return false;
    } else if (fname.length < 2) {
      $("#RegisterForm-fname-error").html("Length should be greater than 1.");
      return false;
    } else {
      $("#RegisterForm-fname-error").html("");
      return true;
    }
  }
  function checkLname(lname) {
    if (lname != '' && !lname.match(/^[A-Za-z\s\-]+$/)) {
      $("#RegisterForm-lname-error").html("Only letters and white space allowed.");
      return false;
    } else if (lname != '' && lname.length < 2) {
      $("#RegisterForm-lname-error").html("Length should be greater than 1.");
      return false;
    } else {
      $("#RegisterForm-lname-error").html("");
      return true;
    }
  }
  function checkEmail(email) {
    if (email === "" || email === " ") {
      $("#RegisterForm-email-error").html("This field is required.");
      return false;
    } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || email.match(/^[0-9]/)) {
      $("#RegisterForm-email-error").html("Invalid email.");
      $error = false;
    } else {
      $("#RegisterForm-email-error").html("");
      return true;
    }
  }
  function checkPsw(psw) {
    if (psw === "") {
      $("#RegisterForm-password-error").html("This field is required.");
      return false;
    }
    else if (psw.length < 8) {
      $("#RegisterForm-password-error").html("Password is too short (minimum is 8 characters).");
      return false;
    } else {
      $("#RegisterForm-password-error").html("");
      return true;
    }
  }


});

// contact form

$(".contact_name").keyup(function () {
  $(".contact-form").attr("onsubmit", '');
  let fname = $(this).val();
  fnameErr = checkContactname(fname);
});
$(".contact_last_name").keyup(function () {
  $(".contact-form").attr("onsubmit", '');
  let surname = $(this).val();
  surnameErr = checkContactsurname(surname);
});

$(".contact_message").keyup(function () {
  $(".contact-form").attr("onsubmit", '');
  let lname = $(this).val();
  lnameErr = checkContactMes(lname);
});
$(".contact_email").keyup(function () {
  $(".contact-form").attr("onsubmit", '');
  let email = $(this).val();
  emailErr = checkContactEmail(email);
});
$(".contact_phone").keyup(function () {
  $(".contact-form").attr("onsubmit", '');
  let psw = $(this).val();
  pswErr = checkContactPhn(psw);
});

$(".contact_order_num").keyup(function () {
  $(".contact-form").attr("onsubmit", '');
  let ordn = $(this).val();
  ordErr = checkContactOrd(ordn);
});

$(".contact-submit").click(function (e) {
  $(".contact-form").attr("onsubmit", '');
  e.preventDefault();
  let error = false;

  var cname = $(".contact_name").val(),
    cmes = $(".contact_message").val(),
  cemail = $(".contact_email").val(),
   cord = $(".contact_order_num").val(),
    csurname = $(".contact_last_name").val(),
  cnameErr = checkContactname(cname),
  mesErr = checkContactMes(cmes),
  cemailErr = checkContactEmail(cemail),
    surnameErr = checkContactsurname(csurname),
  ordErr = checkContactOrd(cord);
  if (cnameErr === true && mesErr === true && cemailErr === true && ordErr === true && surnameErr === true) {
    $(".contact-form").submit();
  }
});
function checkContactname(cname) {
  if (cname === "") {
    $(".nameerror").html("This field is required.");
    return false;
  }else if (cname.charAt(0) === " ") {
    $(".nameerror").html("* Name should not start with Blank Spaces.");
    return false;
  }
  else if (!cname.match(/^[A-Za-z\s\-]+$/)) {
    $(".nameerror").html("Only letters, white space and dash allowed.");
    return false;
  } else if (cname.length < 2) {
    $(".nameerror").html("Length should be greater than 1.");
    return false;
  } else {
    $(".nameerror").html("");
    return true;
  }
}

function checkContactsurname(surname) {
  if (surname === "") {
    $(".surnameerr").html("This field is required.");
    return false;
  }else if (surname.charAt(0) === " ") {
    $(".surnameerr").html("* Name should not start with Blank Spaces.");
    return false;
  }
  else if (!surname.match(/^[A-Za-z\s\-]+$/)) {
    $(".surnameerr").html("Only letters, white space and dash allowed.");
    return false;
  } else if (surname.length < 2) {
    $(".surnameerr").html("Length should be greater than 1.");
    return false;
  } else {
    $(".surnameerr").html("");
    return true;
  }
}
function checkContactEmail(cemail) {
  if (cemail === "" || cemail.charAt(0) === " ") {
    $(".cnemailerror").html("This field is required.");
    return false;
  } else if (!cemail.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || cemail.match(/^[0-9]/)) {
    $(".cnemailerror").html("Invalid email.");
    $error = false;
  } else {
    $(".cnemailerror").html("");
    return true;
  }
}
function checkContactMes(cmes) {
  if (cmes === "") {
    $(".messerror").html("This field is required.");
    return false;
  }else{
    $(".messerror").html("");
    return true;
  }
}
function checkContactOrd(cordn) {
  if($('.order_number_wrapper').css('display') != 'none'){
  if (cordn === "") {
    $(".ordererr").html("This field is required.");
    return false;
  }else{
    $(".ordererr").html("");
    return true;
  }
  }else{
    $(".ordererr").html("");
    return true;
  }
}
function checkContactPhn(cphn) {
  if (cphn === "") {
    $(".phnerror").html("This field is required.");
    return false;
  }else if (cphn.charAt(0) === " ") {
    $(".phnerror").html("* Phone should not start with Blank Spaces.");
    return false;
  }
  else if (!cphn.match(/^[0-9]+[0-9]*$/)){
     $(".phnerror").html("Invalid Number.");
      return false;
  }else{
     $(".phnerror").html("");
    return true;
  }
}

// function featured_slider(){
//   if($(window).width() > 768){
//     $('.ced_carousel').attr('data-flickity','{"cellAlign": "left", "contain": true }')
//   }else{
//     $('.ced_carousel').removeAttr('data-flickity')
//   }
// }
// featured_slider()

// $(window).resize(function(){
//   featured_slider()
  
// });

$('body').delegate('.custom_option_collection','change',function(){
  var custom_option = $(this).data('swatchcustom');
  
  $(this).parent().parent().find('.custom_option_collection').each(function(){
    
    if($(this).data('swatchcustom') == custom_option){
      $(this).prop('checked',true)
      $(this).addClass('swatch_active')
    }else{
      $(this).prop('checked',false)
      $(this).removeClass('swatch_active')
    
    }
  })
  var selected_options = ''
    $(this).closest('.custom_options').find('.custom_option_collection').each(function(){
      if($(this).is(":checked")){
        
        new_symbol ='';
           if(selected_options != ''){
             new_symbol =' / ';
           }
          selected_options = selected_options + new_symbol+ $(this).val()
      }
      
    })
  $(this).closest('.custom_options').next().find('.grid_variant_ced').each(function(){
    
    if($(this).text() == selected_options){
      
      if($(this).data('grid-variant-available') == true){
        
        var err_elem = $(this).parent().next();
        err_elem.text('')
      var grid_variant = $(this).data('grid-variant-id');
      
      let Data = {
      'items': [{
       id: grid_variant,
       quantity: 1
      }]
      };
      $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
            data:  Data,
            success: function(json){
              $('.drawer__contents_cart').css('display','block');
            $('.wishlist_content_cart').css('display','none');
              $("#cartBtn").addClass("btn-active");
            $("#wishlistBtn").removeClass("btn-active");
              get_wishlist()
             var cart = new theme.CartDrawer
              cart.init()
              cart.open();
              
              //Executed after SWYM has loaded all necessary resources.
              
            function onSwymLoadCallback(swat) {
              // Fetch the users wishlist and print it to the console.
                swat.fetch(function(allWishlistedProducts) {
                  // Prints the current users wishlist - 
                  console.log("766");console.log("successfully retrieved the wishlist", allWishlistedProducts);
                  var all_wishproduct = [];
                  for(wish of allWishlistedProducts){
                   all_wishproduct.push(wish.epi)
                  }
                  setTimeout(function(){
                    $('.impulse_cart_item').each(function(){
                    
                    if(all_wishproduct.includes($(this).data('cartvariantid'))){
                      console.log("775");
                      console.log($(this))
                      $(this).find('.move-to-wishlist-btn_impulse').css('display','none');
                      $(this).find('.remove-from-wishlist-btn_impulse').css('display','block')
                    }else{
                      $(this).find('.move-to-wishlist-btn_impulse').css('display','block');
                      $(this).find('.remove-from-wishlist-btn_impulse').css('display','none')
                    }
                  })
                  },1000)
                  
                }, function(error) {
                  console.log("787");
                  console.log("There was an error while fetching the wishlist", error)
                });
            }
              if (!window.SwymCallbacks) {
                window.SwymCallbacks = [];
              }
              window.SwymCallbacks.push(onSwymLoadCallback);
              $.getJSON("/cart.js", function(cart){ 
                    $('.cart-link__bubble').addClass('cart-link__bubble--visible')
                  $('.cart-link__bubble').text('('+cart.item_count+')')
                  })
                $('.custom_option_collection').each(function(){
                  $(this).prop('checked',false)
                  $(this).prop('disabled',false)
                $(this).removeClass('swatch_active')
                  $('.swatch_opt_color_name').text('')
                })
                },
              error:  function(xhr, status, error){console.log("806");console.log(xhr.responseText);}
           })
      }else{
       err_elem.text('Variant Not Available')
      }
    }
  })
})

$('body').delegate('.cart_btn_impulse','click',function(){
  $('.drawer__contents_cart').css('display','flex');
  $('.wishlist_content_cart').css('display','none');
})

$('body').delegate('.wishllist_btn_impulse','click',function(){
   
  $('.drawer__contents_cart').css('display','none');
  $('.wishlist_content_cart').css('display','block');
           
})



//add to wishlist

$('body').delegate('.product_move_to_wishlist_impulse','click',function(){
  var add_prod = $(this);
    var rem_prod = $(this).parent().next()
      
      var wishlistvariantid = parseInt($(this).attr('data-wishlistvariantid'));
      var wishlistproductid = parseInt($(this).attr('data-wishlistproductid'));
      var wishlistproducturl = $(this).attr('data-wishlistproducturl');
 
      
      //Executed after SWYM has loaded all necessary resources.
      
      function onSwymLoadCallback(swat) {
         // Define your "product" before adding it to the wishlist (product).
            let product = {
              epi: wishlistvariantid , // unique variant ID of the product.
              empi: wishlistproductid, // Product ID or master product ID
              du: wishlistproducturl // canonical product url.
            }
        console.log("849");
          console.log(product.epi,product.empi,product.du)
      
          // Add the "product" to the wishlist.
          swat.addToWishList(product, function(response) {
            console.log("854");
            console.log("product successfully added to wishlist", response);
            add_prod.parent().css('display','none')
            rem_prod.css('display','block')
            $('.drawer__contents_cart').css('display','none');
            $('.wishlist_content_cart').css('display','block');
              $("#cartBtn").removeClass("btn-active");
            $("#wishlistBtn").addClass("btn-active");
            get_wishlist()
            var add_wishlist_cart = new theme.CartDrawer
              add_wishlist_cart.init()
              add_wishlist_cart.open();
            addremwishlist()
          }, function(error) {
            console.log("868");
            console.log("there was an error adding the product to wishlist", error);
          });
      }
      
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(onSwymLoadCallback);
})

 //remove from wishlist
    $('body').delegate('.product_remove_from_wishlist_impulse','click',function(){
      var rem_prods = $(this);
      var add_prods = $(this).parent().prev();
      var remove_wishlistvariantid = parseInt($(this).attr('data-wishlistvariantid'));
      var remove_wishlistproductid = parseInt($(this).attr('data-wishlistproductid'));
     
      var remove_wishlistproducturl =  parseInt($(this).attr('data-wishlistproducturl'));
      
      //Executed after SWYM has loaded all necessary resources.
      
      function onSwymLoadCallback(swat) {
         // Define your "product" before adding it to the wishlist (product).
            let product = {
              epi: remove_wishlistvariantid , // unique variant ID of the product.
              empi: remove_wishlistproductid, // Product ID or master product ID
              du: remove_wishlistproducturl // canonical product url.
            }
      
          // Remove the "product" from the wishlist.
          swat.removeFromWishList(product, function(response) {
            console.log("900");
            console.log("product successfully removed from wishlist", response);
            rem_prods.parent().css('display','none')
            add_prods.css('display','block')
            $('.drawer__contents_cart').css('display','none');
            $('.wishlist_content_cart').css('display','block');
            $("#cartBtn").removeClass("btn-active");
            $("#wishlistBtn").addClass("btn-active");
            get_wishlist()
            var remove_wishlist_cart = new theme.CartDrawer
              remove_wishlist_cart.init()
              remove_wishlist_cart.open();
            addremwishlist()
          }, function(error) {
            console.log("914");
          console.log("there was an error while removing the product from wishlist", error, product);
          });
      }
      
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(onSwymLoadCallback);
  
  })

//Executed after SWYM has loaded all necessary resources.
  function onSwymLoadCallback(swat) {
    // Fetch the users wishlist and print it to the console.
      swat.fetch(function(allWishlistedProducts) {
        // Prints the current users wishlist - 
        console.log("931");
        console.log("successfully retrieved the wishlist", allWishlistedProducts);
        var all_wishproduct = [];
        for(wish of allWishlistedProducts){
         all_wishproduct.push(wish.epi)
        }
        $('.wishlist_wrapper_product').each(function(){
          console.log("938");
          console.log($(this).data('productvariantid'))
          if(all_wishproduct.includes($(this).data('productvariantid'))){
            $(this).find('.product_move-to-wishlist-btn_impulse').css('display','none');
            $(this).find('.product_remove-from-wishlist-btn_impulse').css('display','block')
          }else{
            $(this).find('.product_move-to-wishlist-btn_impulse').css('display','block');
            $(this).find('.product_remove-from-wishlist-btn_impulse').css('display','none')
          }
        })
      }, function(error) {
        console.log("949");
        console.log("There was an error while fetching the wishlist", error)
      });
    
    swat.evtLayer.addEventListener("sw:removedfromwishlist", function(eventData) {
      console.log("954");
    console.log("A product was removed from wishlist", eventData);
  // update button state here...
    swat.fetch(function(allWishlistedProducts) {
        // Prints the current users wishlist - 
      console.log("959");
        console.log("successfully retrieved the wishlist", allWishlistedProducts);
        let all_wishproduct = [];
        for(wish of allWishlistedProducts){
         all_wishproduct.push(wish.epi)
        }
        
        setTimeout(function(){
          
          $('.impulse_cart_item').each(function(){
          
          if(all_wishproduct.includes($(this).data('cartvariantid'))){
            $(this).find('.move-to-wishlist-btn_impulse').css('display','none');
            $(this).find('.remove-from-wishlist-btn_impulse').css('display','block')
          }else{
            $(this).find('.move-to-wishlist-btn_impulse').css('display','block');
            $(this).find('.remove-from-wishlist-btn_impulse').css('display','none')
          }
        })
           $('.wishlist_wrapper_product').each(function(){
             console.log("979");
          console.log($(this).attr('data-productvariantid'))
          if(all_wishproduct.includes($(this).attr('data-productvariantid'))){
            $(this).find('.product_move-to-wishlist-btn_impulse').css('display','none');
            $(this).find('.product_remove-from-wishlist-btn_impulse').css('display','block')
          }else{
            $(this).find('.product_move-to-wishlist-btn_impulse').css('display','block');
            $(this).find('.product_remove-from-wishlist-btn_impulse').css('display','none')
          }
        })
          
        },900)
        
      }, function(error) {
      console.log("993");
        console.log("There was an error while fetching the wishlist", error)
      });
});
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);

//faq pagination

jQuery(document).ready(function () {

		//Pagination JS
		//how much items per page to show
		var show_per_page = 20; 
		//getting the amount of elements inside pagingBox div
		var number_of_items = $('#pagingBox').children().length;
		//calculate the number of pages we are going to have
		var number_of_pages = Math.ceil(number_of_items/show_per_page);
		
		//set the value of our hidden input fields
		$('#current_page').val(0);
		$('#show_per_page').val(show_per_page);
		
		//now when we got all we need for the navigation let's make it '
		
		/* 
		what are we going to have in the navigation?
			- link to previous page
			- links to specific pages
			- link to next page
		*/
		var navigation_html = '<a class="previous_link" href="javascript:previous();"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="right-arrow icon"><path d="M15 18L9 12L15 6" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
		var current_link = 0;
		while(number_of_pages > current_link){
			navigation_html += '<a class="page_link" href="javascript:go_to_page(' + current_link +')" longdesc="' + current_link +'">'+ (current_link + 1) +'</a>';
			current_link++;
		}
		navigation_html += '<a class="next_link" href="javascript:next();"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="left-arrow icon"><path d="M9 18L15 12L9 6" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
		
		$('#page_navigation').html(navigation_html);
		
		//add active_page class to the first page link
		$('#page_navigation .page_link:first').addClass('active_page');
		
		//hide all the elements inside pagingBox div
		$('#pagingBox').children().css('display', 'none');
		
		//and show the first n (show_per_page) elements
		$('#pagingBox').children().slice(0, show_per_page).css('display', 'block');
	
});



//Pagination JS

function previous(){
	
	new_page = parseInt($('#current_page').val()) - 1;
	//if there is an item before the current active link run the function
	if($('.active_page').prev('.page_link').length==true){
		go_to_page(new_page);
	}
	
}

function next(){
	new_page = parseInt($('#current_page').val()) + 1;
	//if there is an item after the current active link run the function
	if($('.active_page').next('.page_link').length==true){
		go_to_page(new_page);
	}
	
}
function go_to_page(page_num){
	//get the number of items shown per page
	var show_per_page = parseInt($('#show_per_page').val());
	
	//get the element number where to start the slice from
	start_from = page_num * show_per_page;
	
	//get the element number where to end the slice
	end_on = start_from + show_per_page;
	
	//hide all children elements of pagingBox div, get specific items and show them
	$('#pagingBox').children().css('display', 'none').slice(start_from, end_on).css('display', 'block');
	
	/*get the page link that has longdesc attribute of the current page and add active_page class to it
	and remove that class from previously active page link*/
	$('.page_link[longdesc=' + page_num +']').addClass('active_page').siblings('.active_page').removeClass('active_page');
	
	//update the current page input field
	$('#current_page').val(page_num);
}

//blog pagination

jQuery(document).ready(function () {

		//Pagination JS
		//how much items per page to show
		var blog_show_per_page = 10; 
		//getting the amount of elements inside pagingBox div
		var blog_number_of_items = $('#blog_pagingBox').children().length;
		//calculate the number of pages we are going to have
		var blog_number_of_pages = Math.ceil(blog_number_of_items/blog_show_per_page);
		
		//set the value of our hidden input fields
		$('#blog_current_page').val(0);
		$('#blog_show_per_page').val(blog_show_per_page);
		
		//now when we got all we need for the navigation let's make it '
		
		/* 
		what are we going to have in the navigation?
			- link to previous page
			- links to specific pages
			- link to next page
		*/
		var blog_navigation_html = '<a class="blog_previous_link" href="javascript:blog_previous();"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="right-arrow icon"><path d="M15 18L9 12L15 6" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
		var blog_current_link = 0;
		while(blog_number_of_pages > blog_current_link){
			blog_navigation_html += '<a class="blog_page_link" href="javascript:blog_go_to_page(' + blog_current_link +')" longdesc="' + blog_current_link +'">'+ (blog_current_link + 1) +'</a>';
			blog_current_link++;
		}
		blog_navigation_html += '<a class="blog_next_link" href="javascript:blog_next();"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="left-arrow icon"><path d="M9 18L15 12L9 6" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
		
		$('#blog_page_navigation').html(blog_navigation_html);
		
		//add active_page class to the first page link
		$('#blog_page_navigation .blog_page_link:first').addClass('blog_active_page');
		
		//hide all the elements inside pagingBox div
		$('#blog_pagingBox').children().css('display', 'none');
		
		//and show the first n (show_per_page) elements
		$('#blog_pagingBox').children().slice(0, blog_show_per_page).css('display', 'block');
	
});



//Pagination JS

function blog_previous(){
	
	blog_new_page = parseInt($('#blog_current_page').val()) - 1;
	//if there is an item before the current active link run the function
	if($('.blog_active_page').prev('.blog_page_link').length==true){
		blog_go_to_page(blog_new_page);
	}
	
}

function blog_next(){
	blog_new_page = parseInt($('#blog_current_page').val()) + 1;
	//if there is an item after the current active link run the function
	if($('.blog_active_page').next('.blog_page_link').length==true){
		go_to_page(new_page);
	}
	
}
function blog_go_to_page(blog_page_num){
	//get the number of items shown per page
	var blog_show_per_page = parseInt($('#blog_show_per_page').val());
	
	//get the element number where to start the slice from
	blog_start_from = blog_page_num * blog_show_per_page;
	
	//get the element number where to end the slice
	blog_end_on = blog_start_from + blog_show_per_page;
	
	//hide all children elements of pagingBox div, get specific items and show them
	$('#blog_pagingBox').children().css('display', 'none').slice(blog_start_from, blog_end_on).css('display', 'block');
	
	/*get the page link that has longdesc attribute of the current page and add active_page class to it
	and remove that class from previously active page link*/
	$('.blog_page_link[longdesc=' + blog_page_num +']').addClass('blog_active_page').siblings('.blog_active_page').removeClass('blog_active_page');
	
	//update the current page input field
	$('#blog_current_page').val(blog_page_num);
}

$(document).ready(function() {
    
    $('#SortBy>option[value=best-selling]').insertAfter('#SortBy>option[value=created-descending]')
    
    $('#SortBy>option[value=price-ascending]').insertAfter('#SortBy>option[value=best-selling]')
    $('#SortBy>option[value=price-descending]').insertAfter('#SortBy>option[value=price-ascending]')
    $('#SortBy>option[value=title-ascending]').insertAfter('#SortBy>option[value=price-descending]')
  $('#SortBy>option[value=title-descending]').insertAfter('#SortBy>option[value=title-ascending]')
    
});


// $('.impulse_variant-input-wrap').each(function(){
//   if($(this).data('index') != 'option1'){
//     $(this).prop('disabled',true)
//   }
// })

$('.scroll-top-bottom_wrap').css('display','none !important');


$(window).scroll(function(){
  if ($(window).scrollTop() >= 330) {
    $('.scroll-top-bottom_wrap').css('display','grid');
    $('.scroll-top-bottom_wrap').css('visibility','visible');
   }
   else {
   $('.scroll-top-bottom_wrap').css('display','none');
      $('.scroll-top-bottom_wrap').css('visibility','hidden');
   }
});

$('body').delegate('.col_color_swatch_custom','change',function(){
  $(this).closest('.custom_options_value').prev().text($(this).val())
})

$('body').delegate('.delete_cart_item','click',function(){
  var datakey = $(this).parent().data('key')
  $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
     data: {
  'id': datakey,
  'quantity': 0
  }
   })
   .then(data => {
  var cart = new theme.CartDrawer
              cart.init()
              cart.open();
     //Executed after SWYM has loaded all necessary resources.
  function onSwymLoadCallback(swat) {
    // Fetch the users wishlist and print it to the console.
      swat.fetch(function(allWishlistedProducts) {
        // Prints the current users wishlist - 
        console.log("1235");
        console.log("successfully retrieved the wishlist", allWishlistedProducts);
        var all_wishproduct = [];
        for(wish of allWishlistedProducts){
         all_wishproduct.push(wish.epi)
        }
        setTimeout(function(){
          $('.impulse_cart_item').each(function(){
          
          if(all_wishproduct.includes($(this).data('cartvariantid'))){
            $(this).find('.move-to-wishlist-btn_impulse').css('display','none');
            $(this).find('.remove-from-wishlist-btn_impulse').css('display','block')
          }else{
            $(this).find('.move-to-wishlist-btn_impulse').css('display','block');
            $(this).find('.remove-from-wishlist-btn_impulse').css('display','none')
          }
        })
        },1000)
        
      }, function(error) {
        console.log("1255");
        console.log("There was an error while fetching the wishlist", error)
      });
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
})
})

$('body').delegate('.imp_js-qty__adjust','click',function(){
  setTimeout(function(){
  $('#cart-link__bubble').load(' #cart-link__bubble')
  $('#cart-link__bubble_mobile').load(' #cart-link__bubble_mobile')
  },1000)
})

$('body').delegate('.impulse_collapsible-trigger','click',function(){
  var parentblock = $(this).closest('.impulse_mobile-nav__item')
  var blocknumber = parentblock.find('.impulse_collapsible-content').data('blocknumber')
  var blockbutton = parentblock.find('.impulse_collapsible-trigger').data('blockbutton')
  $('.impulse_collapsible-content').each(function(){
    if(blocknumber != $(this).data('blocknumber')){
      $(this).removeClass('is-open')
      $(this).css('height','0px')
    }
  })
  $('.impulse_collapsible-trigger').each(function(){
    if(blockbutton != $(this).data('blockbutton')){
      $(this).removeClass('is-open')
      $(this).attr("aria-expanded","false");
    }
  })
})


$('body').delegate('.zoom_nxt_btn','click',function(){
  $('.zoom_thumbnail_wrapper').each(function(){
    if($(this).hasClass('zoom_thumbnail_active')){
      if($(this).next().css('display') != 'none'){
        $('.containerZoom').css('background-image', 'url(' + $(this).next().children().attr('src') + ')');
        $('.zoom_image_wrap img').attr('src',$(this).next().children().attr('src'))
          $(this).removeClass('zoom_thumbnail_active')
          $(this).next().addClass('zoom_thumbnail_active')
        return false;
      }
      
    }
  })
})

$('body').delegate('.zoom_prev_btn','click',function(){
  $('.zoom_thumbnail_wrapper').each(function(){
    if($(this).hasClass('zoom_thumbnail_active')){
      if($(this).prev().css('display') != 'none'){
        $('.containerZoom').css('background-image', 'url(' + $(this).prev().children().attr('src') + ')');
        $('.zoom_image_wrap img').attr('src',$(this).prev().children().attr('src'))
          $(this).removeClass('zoom_thumbnail_active')
          $(this).prev().addClass('zoom_thumbnail_active')
        return false;
      }
      
    }
  })
})

//newsletter-start

  $(".news_letter_submit").click(function (e) {
    e.preventDefault();
    var email_nl = $(".footer_newsletter_email").val();
  
    emailErr_nl = newsletter_checkEmail(email_nl);
   
    if (emailErr_nl === true ) {
      $(".footer_newsletter").submit();
    }
  });
  
  function newsletter_checkEmail(email) {
   console.log(email.charAt(0) )
    if (email === "") {
      $(".emailerror_nl").html("Email required.");
      return false;
    }else if(email.charAt(0) == " "){
      $(".emailerror_nl").html("Invalid email");
      return false;
    } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || email.match(/^[0-9]/) ) {
      $(".emailerror_nl").html("Invalid email.");
      return false;
      // $error = false;
    } else {
      $(".emailerror_nl").html("");
      return true;
    }
  }
  
  $(".footer_newsletter_email").keyup(function () {
    
    $(".footer_newsletter").attr("onsubmit", "");
    let email = $(this).val();
    emailErr = newsletter_checkEmail(email);
  });



  //newsletter-end

$('body').delegate('.custom_option_collection','change',function(){
  var optionvaluecompare = $(this).val();
  var optionnamecomapre = $(this).parent().parent().data('optionnameforvalue')
  var comparr = [];
  $(this).closest('.custom_options').next().find('.grid_variant_ced').each(function(){
    var alloptioncompare = $(this).text().split('/').map(function (value) {
   return value.trim();
  });
    if(alloptioncompare.includes(optionvaluecompare) && $(this).data('grid-variant-available')){
      var optioncompareindex = alloptioncompare.indexOf(optionvaluecompare)
      alloptioncompare.splice(optioncompareindex,1)
      comparr.push(...alloptioncompare)
    }
  })
  // console.log(comparr)
  var newcomparr = [...new Set(comparr)]
  $(this).closest('.custom_options').find('.custom_options_value').each(function(){
    if($(this).data('optionnameforvalue') != optionnamecomapre){
      $(this).find('.custom_option_collection').each(function(){
        if(newcomparr.includes($(this).val())){
          $(this).prop('disabled',false)
        }else{
          $(this).prop('disabled',true)
        }
      })
    }
  })
})

$('body').delegate('.custom-add-to-cart-pr','click',function(){
  setTimeout(()=>{
    addremwishlist()
     $.getJSON("/cart.js", function(cart){ 
    $('.cart-link__bubble').addClass('cart-link__bubble--visible')
  $('.cart-link__bubble').text('('+cart.item_count+')')
  })
  },500)
 
  
})

$('body').delegate('.meta_product_link','click',function(e){
  e.preventDefault()
  const meta_product_link = $(this).attr('data-metaproductlink');
  location.href = meta_product_link
})

$('body').delegate('.options_impulse_btn','change',function(){
  setTimeout(() => {
    let opt_urlParams = new URLSearchParams(window.location.search);
    let opt_variant_id = opt_urlParams.get("variant");
    let opt_wishListBtns = document.querySelectorAll("[data-ced-wishlist='']");
    opt_wishListBtns.forEach((btn) => {
      btn.setAttribute("data-wishlistvariantid", opt_variant_id);
    })
    $('.wishlist_wrapper_product').attr('data-productvariantid',opt_variant_id)
    //Executed after SWYM has loaded all necessary resources.
  function onSwymLoadCallback(swat) {
    // Fetch the users wishlist and print it to the console.
      swat.fetch(function(allWishlistedProducts) {
        // Prints the current users wishlist - 
        // console.log("successfully retrieved the wishlist", allWishlistedProducts);
        var all_wishproduct = [];
        for(wish of allWishlistedProducts){
         all_wishproduct.push(wish.epi)
        }
        
        $('.wishlist_wrapper_product').each(function(){
          console.log("1432");
          console.log(all_wishproduct,$(this).attr('data-productvariantid'))
          if(all_wishproduct.includes(parseInt($(this).attr('data-productvariantid')))){
            console.log("1435");
            console.log('in')
            $(this).find('.product_move-to-wishlist-btn_impulse').css('display','none');
            $(this).find('.product_remove-from-wishlist-btn_impulse').css('display','block')
          }else{
            console.log("1440");
            console.log('out')
            $(this).find('.product_move-to-wishlist-btn_impulse').css('display','block');
            $(this).find('.product_remove-from-wishlist-btn_impulse').css('display','none')
          }
        })
      }, function(error) {
        console.log("1447");
        console.log("There was an error while fetching the wishlist", error)
      });
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
  },900)
})

$('body').delegate('.variant__input--color-swatch','click',function(){
  window.scroll({
          top: 0,
          behavior: 'smooth'
        });
})